import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";
import qs from 'qs';

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const payrollSummaryStagingService = {

  getProcessedPayroll: async (payload) => {
    const response = await axios.get(`${domain}/api/PayrollSummaryStaging/processed`, {
      params: payload,
      headers: headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, {
          arrayFormat: 'indices',
          allowDots: true
        });
      }
    });
    return response;
  },
  
  // Main Payroll Functions
  processPayroll: async (param) => {
    const apiUrl = `${domain}/api/PayrollSummaryStaging/process/${param}`;
    return await axios.post(apiUrl, null, { headers });
  },
  revertPayroll: async (param) => {
    const apiUrl = `${domain}/api/PayrollSummaryStaging/revert/${param}`;
		return await axios.post(apiUrl, null, { headers });
  },
  postPayroll: async (param) => {
    const apiUrl = `${domain}/api/PayrollSummaryStaging/post/${param}`;
		return await axios.post(apiUrl, null, { headers });
  }

};